module.exports = __webpack_public_path__ + "img/waving-hand.8063b776.svg";